import { Link } from 'react-router-dom';
import { ShieldOff, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function ForbiddenPage() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center">
      <div className="h-14 w-14 rounded-sm border border-danger/40 flex items-center justify-center mb-6">
        <ShieldOff className="text-danger" size={22} />
      </div>
      <div className="kicker text-danger mb-3">403 · Forbidden</div>
      <h1 className="font-display text-4xl text-text mb-3">Access Restricted</h1>
      <p className="text-text-muted max-w-md mb-8">
        Your role does not have permission to view this module. If you believe this is
        a mistake, contact an owner or IT administrator.
      </p>
      <Link to="/">
        <Button variant="secondary" leftIcon={<ArrowLeft size={14} />}>
          Back to Dashboard
        </Button>
      </Link>
    </div>
  );
}
